// Automatically generated exact race results data for F1 2026 Championship
// Do not modify manually. Re-run generator script if necessary.

export const resultsData = {
  "1": {
    "raceId": 1,
    "gp": "Australia",
    "raceResults": [
      {
        "position": 1,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 25
      },
      {
        "position": 2,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 18
      },
      {
        "position": 3,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 15
      },
      {
        "position": 4,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 12
      },
      {
        "position": 5,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 10
      },
      {
        "position": 6,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 8
      },
      {
        "position": 7,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 6
      },
      {
        "position": 8,
        "driver": "Isack Hadjar",
        "team": "Red Bull Ford",
        "flag": "🇫🇷",
        "points": 4
      },
      {
        "position": 9,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 2
      },
      {
        "position": 10,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 1
      },
      {
        "position": 11,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      }
    ],
    "sprintResults": null
  },
  "2": {
    "raceId": 2,
    "gp": "China",
    "raceResults": [
      {
        "position": 1,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 25
      },
      {
        "position": 2,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 18
      },
      {
        "position": 3,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 15
      },
      {
        "position": 4,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 12
      },
      {
        "position": 5,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 10
      },
      {
        "position": 6,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 8
      },
      {
        "position": 7,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 6
      },
      {
        "position": 8,
        "driver": "Isack Hadjar",
        "team": "Red Bull Ford",
        "flag": "🇫🇷",
        "points": 4
      },
      {
        "position": 9,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 2
      },
      {
        "position": 10,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 1
      },
      {
        "position": 11,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      }
    ],
    "sprintResults": [
      {
        "position": 1,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 8
      },
      {
        "position": 2,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 7
      },
      {
        "position": 3,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 6
      },
      {
        "position": 4,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 5
      },
      {
        "position": 5,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 4
      },
      {
        "position": 6,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 3
      },
      {
        "position": 7,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 2
      },
      {
        "position": 8,
        "driver": "Isack Hadjar",
        "team": "Red Bull Ford",
        "flag": "🇫🇷",
        "points": 1
      },
      {
        "position": 9,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 10,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 0
      },
      {
        "position": 11,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      }
    ]
  },
  "3": {
    "raceId": 3,
    "gp": "Japón",
    "raceResults": [
      {
        "position": 1,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 25
      },
      {
        "position": 2,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 18
      },
      {
        "position": 3,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 15
      },
      {
        "position": 4,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 12
      },
      {
        "position": 5,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 10
      },
      {
        "position": 6,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 8
      },
      {
        "position": 7,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 6
      },
      {
        "position": 8,
        "driver": "Isack Hadjar",
        "team": "Red Bull Ford",
        "flag": "🇫🇷",
        "points": 4
      },
      {
        "position": 9,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 2
      },
      {
        "position": 10,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 1
      },
      {
        "position": 11,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      }
    ],
    "sprintResults": null
  },
  "4": {
    "raceId": 4,
    "gp": "Bahréin",
    "raceResults": null,
    "sprintResults": null
  },
  "5": {
    "raceId": 5,
    "gp": "Arabia Saudita",
    "raceResults": null,
    "sprintResults": null
  },
  "6": {
    "raceId": 6,
    "gp": "Miami",
    "raceResults": [
      {
        "position": 1,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 25
      },
      {
        "position": 2,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 18
      },
      {
        "position": 3,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 15
      },
      {
        "position": 4,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 12
      },
      {
        "position": 5,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 10
      },
      {
        "position": 6,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 8
      },
      {
        "position": 7,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 6
      },
      {
        "position": 8,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 4
      },
      {
        "position": 9,
        "driver": "Isack Hadjar",
        "team": "Red Bull Ford",
        "flag": "🇫🇷",
        "points": 2
      },
      {
        "position": 10,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 1
      },
      {
        "position": 11,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      }
    ],
    "sprintResults": [
      {
        "position": 1,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 8
      },
      {
        "position": 2,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 7
      },
      {
        "position": 3,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 6
      },
      {
        "position": 4,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 5
      },
      {
        "position": 5,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 4
      },
      {
        "position": 6,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 3
      },
      {
        "position": 7,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 2
      },
      {
        "position": 8,
        "driver": "Isack Hadjar",
        "team": "Red Bull Ford",
        "flag": "🇫🇷",
        "points": 1
      },
      {
        "position": 9,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 10,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 0
      },
      {
        "position": 11,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      }
    ]
  },
  "7": {
    "raceId": 7,
    "gp": "Canadá",
    "raceResults": [
      {
        "position": 1,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 25
      },
      {
        "position": 2,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 18
      },
      {
        "position": 3,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 15
      },
      {
        "position": 4,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 12
      },
      {
        "position": 5,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 10
      },
      {
        "position": 6,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 8
      },
      {
        "position": 7,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 6
      },
      {
        "position": 8,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 4
      },
      {
        "position": 9,
        "driver": "Isack Hadjar",
        "team": "Red Bull Ford",
        "flag": "🇫🇷",
        "points": 2
      },
      {
        "position": 10,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 1
      },
      {
        "position": 11,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      }
    ],
    "sprintResults": [
      {
        "position": 1,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 8
      },
      {
        "position": 2,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 7
      },
      {
        "position": 3,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 6
      },
      {
        "position": 4,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 5
      },
      {
        "position": 5,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 4
      },
      {
        "position": 6,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 3
      },
      {
        "position": 7,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 2
      },
      {
        "position": 8,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 1
      },
      {
        "position": 9,
        "driver": "Isack Hadjar",
        "team": "Red Bull Ford",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 10,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 11,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      }
    ]
  },
  "8": {
    "raceId": 8,
    "gp": "Mónaco",
    "raceResults": [
      {
        "position": 1,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 25
      },
      {
        "position": 2,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 18
      },
      {
        "position": 3,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 15
      },
      {
        "position": 4,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 12
      },
      {
        "position": 5,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 10
      },
      {
        "position": 6,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 8
      },
      {
        "position": 7,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 6
      },
      {
        "position": 8,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 4
      },
      {
        "position": 9,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 2
      },
      {
        "position": 10,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 1
      },
      {
        "position": 11,
        "driver": "Isack Hadjar",
        "team": "Red Bull Ford",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      }
    ],
    "sprintResults": null
  },
  "9": {
    "raceId": 9,
    "gp": "España",
    "raceResults": [
      {
        "position": 1,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 25
      },
      {
        "position": 2,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 18
      },
      {
        "position": 3,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 15
      },
      {
        "position": 4,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 12
      },
      {
        "position": 5,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 10
      },
      {
        "position": 6,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 8
      },
      {
        "position": 7,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 6
      },
      {
        "position": 8,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 4
      },
      {
        "position": 9,
        "driver": "Isack Hadjar",
        "team": "Red Bull Ford",
        "flag": "🇫🇷",
        "points": 2
      },
      {
        "position": 10,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 1
      },
      {
        "position": 11,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      }
    ],
    "sprintResults": null
  },
  "10": {
    "raceId": 10,
    "gp": "Austria",
    "raceResults": [
      {
        "position": 1,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 25
      },
      {
        "position": 2,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 18
      },
      {
        "position": 3,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 15
      },
      {
        "position": 4,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 12
      },
      {
        "position": 5,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 10
      },
      {
        "position": 6,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 8
      },
      {
        "position": 7,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 6
      },
      {
        "position": 8,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 4
      },
      {
        "position": 9,
        "driver": "Isack Hadjar",
        "team": "Red Bull Ford",
        "flag": "🇫🇷",
        "points": 2
      },
      {
        "position": 10,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 1
      },
      {
        "position": 11,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      }
    ],
    "sprintResults": null
  },
  "11": {
    "raceId": 11,
    "gp": "Gran Bretaña",
    "raceResults": [
      {
        "position": 1,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 25
      },
      {
        "position": 2,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 18
      },
      {
        "position": 3,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 15
      },
      {
        "position": 4,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 12
      },
      {
        "position": 5,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 10
      },
      {
        "position": 6,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 8
      },
      {
        "position": 7,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 6
      },
      {
        "position": 8,
        "driver": "Isack Hadjar",
        "team": "Red Bull Ford",
        "flag": "🇫🇷",
        "points": 4
      },
      {
        "position": 9,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 2
      },
      {
        "position": 10,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 1
      },
      {
        "position": 11,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      }
    ],
    "sprintResults": [
      {
        "position": 1,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 8
      },
      {
        "position": 2,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 7
      },
      {
        "position": 3,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 6
      },
      {
        "position": 4,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 5
      },
      {
        "position": 5,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 4
      },
      {
        "position": 6,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 3
      },
      {
        "position": 7,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 2
      },
      {
        "position": 8,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 1
      },
      {
        "position": 9,
        "driver": "Isack Hadjar",
        "team": "Red Bull Ford",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 10,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 0
      },
      {
        "position": 11,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      }
    ]
  },
  "12": {
    "raceId": 12,
    "gp": "Bélgica",
    "raceResults": [
      {
        "position": 1,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 25
      },
      {
        "position": 2,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 18
      },
      {
        "position": 3,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 15
      },
      {
        "position": 4,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 12
      },
      {
        "position": 5,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 10
      },
      {
        "position": 6,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 8
      },
      {
        "position": 7,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 6
      },
      {
        "position": 8,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 4
      },
      {
        "position": 9,
        "driver": "Isack Hadjar",
        "team": "Red Bull Ford",
        "flag": "🇫🇷",
        "points": 2
      },
      {
        "position": 10,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 1
      },
      {
        "position": 11,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      }
    ],
    "sprintResults": null
  },
  "13": {
    "raceId": 13,
    "gp": "Hungría",
    "raceResults": [
      {
        "position": 1,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 25
      },
      {
        "position": 2,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 18
      },
      {
        "position": 3,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 15
      },
      {
        "position": 4,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 12
      },
      {
        "position": 5,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 10
      },
      {
        "position": 6,
        "driver": "Isack Hadjar",
        "team": "Red Bull Ford",
        "flag": "🇫🇷",
        "points": 8
      },
      {
        "position": 7,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 6
      },
      {
        "position": 8,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 4
      },
      {
        "position": 9,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 2
      },
      {
        "position": 10,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 1
      },
      {
        "position": 11,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": "DNF",
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 0
      },
      {
        "position": "DNF",
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": "DNF",
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      }
    ],
    "sprintResults": null
  },
  "14": {
    "raceId": 14,
    "gp": "Países Bajos",
    "raceResults": [
      {
        "position": 1,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 25
      },
      {
        "position": 2,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 18
      },
      {
        "position": 3,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 15
      },
      {
        "position": 4,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 12
      },
      {
        "position": 5,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 10
      },
      {
        "position": 6,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 8
      },
      {
        "position": 7,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 6
      },
      {
        "position": 8,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 4
      },
      {
        "position": 9,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 2
      },
      {
        "position": 10,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 1
      },
      {
        "position": 11,
        "driver": "Yuki Tsunoda",
        "team": "Racing Bulls (RB)",
        "flag": "🇯🇵",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 0
      }
    ],
    "sprintResults": [
      {
        "position": 1,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 8
      },
      {
        "position": 2,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 7
      },
      {
        "position": 3,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 6
      },
      {
        "position": 4,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 5
      },
      {
        "position": 5,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 4
      },
      {
        "position": 6,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 3
      },
      {
        "position": 7,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 2
      },
      {
        "position": 8,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 1
      },
      {
        "position": 9,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 10,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 11,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Yuki Tsunoda",
        "team": "Racing Bulls (RB)",
        "flag": "🇯🇵",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 0
      }
    ]
  },
  "15": {
    "raceId": 15,
    "gp": "Italia",
    "raceResults": [
      {
        "position": 1,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 25
      },
      {
        "position": 2,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 18
      },
      {
        "position": 3,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 15
      },
      {
        "position": 4,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 12
      },
      {
        "position": 5,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 10
      },
      {
        "position": 6,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 8
      },
      {
        "position": 7,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 6
      },
      {
        "position": 8,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 4
      },
      {
        "position": 9,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 2
      },
      {
        "position": 10,
        "driver": "Yuki Tsunoda",
        "team": "Racing Bulls (RB)",
        "flag": "🇯🇵",
        "points": 1
      },
      {
        "position": 11,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 0
      }
    ],
    "sprintResults": null
  },
  "16": {
    "raceId": 16,
    "gp": "España - Madrid",
    "raceResults": [
      {
        "position": 1,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 25
      },
      {
        "position": 2,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 18
      },
      {
        "position": 3,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 15
      },
      {
        "position": 4,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 12
      },
      {
        "position": 5,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 10
      },
      {
        "position": 6,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 8
      },
      {
        "position": 7,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 6
      },
      {
        "position": 8,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 4
      },
      {
        "position": 9,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 2
      },
      {
        "position": 10,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 1
      },
      {
        "position": 11,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Yuki Tsunoda",
        "team": "Racing Bulls (RB)",
        "flag": "🇯🇵",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 0
      }
    ],
    "sprintResults": null
  },
  "17": {
    "raceId": 17,
    "gp": "Azerbaiyán",
    "raceResults": [
      {
        "position": 1,
        "driver": "George Russell",
        "team": "Mercedes",
        "flag": "🇬🇧",
        "points": 25
      },
      {
        "position": 2,
        "driver": "Max Verstappen",
        "team": "Red Bull Ford",
        "flag": "🇳🇱",
        "points": 18
      },
      {
        "position": 3,
        "driver": "Isack Hadjar",
        "team": "Red Bull Ford",
        "flag": "🇫🇷",
        "points": 15
      },
      {
        "position": 4,
        "driver": "Charles Leclerc",
        "team": "Ferrari",
        "flag": "🇲🇨",
        "points": 12
      },
      {
        "position": 5,
        "driver": "Kimi Antonelli",
        "team": "Mercedes",
        "flag": "🇮🇹",
        "points": 10
      },
      {
        "position": 6,
        "driver": "Lewis Hamilton",
        "team": "Ferrari",
        "flag": "🇬🇧",
        "points": 8
      },
      {
        "position": 7,
        "driver": "Arvid Lindblad",
        "team": "Racing Bulls (RB)",
        "flag": "🇬🇧",
        "points": 6
      },
      {
        "position": 8,
        "driver": "Esteban Ocon",
        "team": "Haas",
        "flag": "🇫🇷",
        "points": 4
      },
      {
        "position": 9,
        "driver": "Oliver Bearman",
        "team": "Haas",
        "flag": "🇬🇧",
        "points": 2
      },
      {
        "position": 10,
        "driver": "Carlos Sainz",
        "team": "Williams",
        "flag": "🇪🇸",
        "points": 1
      },
      {
        "position": 11,
        "driver": "Nico Hülkenberg",
        "team": "Audi",
        "flag": "🇩🇪",
        "points": 0
      },
      {
        "position": 12,
        "driver": "Liam Lawson",
        "team": "Racing Bulls (RB)",
        "flag": "🇳🇿",
        "points": 0
      },
      {
        "position": 13,
        "driver": "Oscar Piastri",
        "team": "McLaren",
        "flag": "🇦🇺",
        "points": 0
      },
      {
        "position": 14,
        "driver": "Sergio Pérez",
        "team": "Cadillac",
        "flag": "🇲🇽",
        "points": 0
      },
      {
        "position": 15,
        "driver": "Gabriel Bortoleto",
        "team": "Audi",
        "flag": "🇧🇷",
        "points": 0
      },
      {
        "position": 16,
        "driver": "Valtteri Bottas",
        "team": "Cadillac",
        "flag": "🇫🇮",
        "points": 0
      },
      {
        "position": 17,
        "driver": "Franco Colapinto",
        "team": "Alpine",
        "flag": "🇦🇷",
        "points": 0
      },
      {
        "position": 18,
        "driver": "Pierre Gasly",
        "team": "Alpine",
        "flag": "🇫🇷",
        "points": 0
      },
      {
        "position": 19,
        "driver": "Lando Norris",
        "team": "McLaren",
        "flag": "🇬🇧",
        "points": 0
      },
      {
        "position": 20,
        "driver": "Alex Albon",
        "team": "Williams",
        "flag": "🇹🇭",
        "points": 0
      },
      {
        "position": 21,
        "driver": "Fernando Alonso",
        "team": "Aston Martin Honda",
        "flag": "🇪🇸",
        "points": 0
      },
      {
        "position": 22,
        "driver": "Lance Stroll",
        "team": "Aston Martin Honda",
        "flag": "🇨🇦",
        "points": 0
      }
    ],
    "sprintResults": null
  },
  "18": {
    "raceId": 18,
    "gp": "Malasia",
    "raceResults": null,
    "sprintResults": null
  },
  "19": {
    "raceId": 19,
    "gp": "Singapur",
    "raceResults": null,
    "sprintResults": null
  },
  "20": {
    "raceId": 20,
    "gp": "Estados Unidos",
    "raceResults": null,
    "sprintResults": null
  },
  "21": {
    "raceId": 21,
    "gp": "México",
    "raceResults": null,
    "sprintResults": null
  },
  "22": {
    "raceId": 22,
    "gp": "Brasil",
    "raceResults": null,
    "sprintResults": null
  },
  "23": {
    "raceId": 23,
    "gp": "Las Vegas",
    "raceResults": null,
    "sprintResults": null
  },
  "24": {
    "raceId": 24,
    "gp": "Qatar",
    "raceResults": null,
    "sprintResults": null
  },
  "25": {
    "raceId": 25,
    "gp": "Abu Dhabi",
    "raceResults": null,
    "sprintResults": null
  }
};
